module.exports = __webpack_public_path__ + "img/activePageMBgEn.5f6c7a6b.png";